// iPhone never fires beforeinstallprompt. Chrome on iPhone (CriOS) puts
// Add to Home Screen on the Share control next to the address bar
// (Google Chrome Help). Safari keeps the shorter Share line. Safari
// wording is used only when the browser is Safari.

export function isIosUserAgent(ua: string, macTouch = false): boolean {
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return ua.includes('Mac') && macTouch;
}

const NON_SAFARI_IOS = /CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/;

export function isIosSafari(ua: string, macTouch = false): boolean {
  return isIosUserAgent(ua, macTouch) && !NON_SAFARI_IOS.test(ua);
}

export const IOS_CHROME_INSTALL =
  'Tap Share next to the address bar, then Add to Home Screen.';

export const IOS_SAFARI_INSTALL = 'Tap Share, then Add to Home Screen.';

export function iosInstallInstructions(ua: string, macTouch = false): string {
  return isIosSafari(ua, macTouch) ? IOS_SAFARI_INSTALL : IOS_CHROME_INSTALL;
}
